import $ from "jquery";

export function parallax() {
  // Agregar `parallaxScroll` como un plugin de jQuery
  $.fn.parallaxScroll = function () {
    var $window = $(window);

    return this.each(function() {
      var $bgobj = $(this);

      $window.on("scroll", function() {
        var yPos = -($(window).scrollTop() / $bgobj.data("background-parallax"));
        var coords = "50% " + yPos + "px";
        $bgobj.css({ backgroundPosition: coords });
      });
    });
  };

  // Aplicar el efecto a los elementos con el atributo `data-background-parallax`
  $("[data-background-parallax]").parallaxScroll();
}
